module.exports = __webpack_public_path__ + "img/237.012d3d49.jpg";